export const LocaleJa = {
  memo: {
    draftRevived: '下書きを復元しますか？',
    draftRevived2: '編集中のメモのバックアップを復元しますか？',
    save: 'メモを保存します。よろしいですか？',
    draft_save: '下書きを保存します。よろしいですか？',
    title: 'タイトル',
    title_blank: 'タイトル未設定',
    message: '本文',
    memo_tag: 'タグ',
    brand: '銘柄',
    investment: 'レーティング・メモ',
  },
  sign: {
    redIncrease: '赤増',
    redDecrease: '赤減',
    changeRed: '赤転',
    changeBlack: '黒転',
  },
  histogram: {
    yourEst: '予想',
    consensus: '市場',
    alertText: '検索したい年度の予想値を再度保存していただいてから、もう一度検索してください。'
  },
  chat: {
    banner: 'チャット',
    placeHolder: 'メッセージをどうぞ... (Ctrl+Enterキーで送信) ※記名投稿',
    submitBtn: '送信',
    BBS: '掲示板',
    channel: 'チャンネル',
    DM: 'DM',
    follow: 'フォロー',
    follower: 'フォロワー',
    createChannel: {
      promptMsg: '作成するチャンネル名を入力してください...(最大20文字)',
      alert: 'チャンネル名は1～20文字以内で入力下さい',
    },
    channelUser: 'メンバー',
    addChannelUser: 'チャンネルに追加しますか？',
    deleteChannel: 'グループチャット {{channelName}} を削除しますか？',
    deleteMessage: 'メッセージを削除しますか？',
    transmissionTime: {
      aFewSecondAgo: '数秒前',
      secondsAgo: '秒前',
      withinOneMinute: '1分以内',
      minutesAgo: '分前',
      withinOneHour: '1時間以内',
      hoursAgo: '時間前',
      yesterday: '昨日',
      daysAgo: '日前',
    }
  },
  ticker: {
    targetPrice: {
      alertText: '目標株価を更新できませんでした',
    }
  },
  addTickerToCoverage: {
    error: {
      alreadyAdded: '既に追加されています。',
      notExist: '追加しようとしたグループは存在しません。'
    }
  },
  stockChart: {
    title: '株価・{{ bar }}・PER',
    titleUs: '株価',
    yAxis: {
      label: {
        JP: '株価(円)',
        US: '株価(USD)'
      },
      billion: '(十億円)',
      yen: '(円)'
    },
    barType: {
      revenue: '売上高',
      gp: '売上総利益',
      op: '営業利益',
      ebt: '税前利益',
      income: '純利益',
      dps: 'DPS',
    }
  },
  targetStockList: {
    label: {
      targetDate: '予想対象日',
      stock: '株価 ',
      tpHi: '目標株価',
      tpLow: 'リスク値'
    },
    btn: {
      save: '保存',
      saved: '保存済',
      delete: '削除'
    },
    errors: {
      eitherOneHasValue: '株価(高)は必須項目です。*リスク値は未入力でも保存できます',
      maximumGreaterThanMinimum: '目標株価 >= リスク値となるように値を入力してください',
      moreMinorityOrLess: '小数点以下は2桁までかつ、0.01以上の数値を入力してください',
      blankTargetData: '予想対象日を入力してください',
      afterToday: '予想対象日は本日以降を選択してください。*本日より前のデータは削除のみ可能です',
      upToFiveYears: '５年後まで予想可能です',
      alreadyExist: '{{ targetDate }}はすでに存在します',
      failedToSave: '保存できませんでした',
      failedToDelete: '削除できませんでした'
    }
  },
  trackerChart: {
    actual: '実績値',
    guidance: '計画値',
    fix: '計画値',
    estimation: '予想値',
    published_at: '発表日',
    type: {
      revenue: '売上高(十億円)',
      op: '営業利益(十億円)',
      rp: '経常利益(十億円)',
      ebt: '税前利益(十億円)',
      income: '純利益(十億円)',
      eps: '一株益(円)',
      dps: '一株配(円)'
    }
  },
  relativeChart: {
    yAxis: {
      label: '変化率',
    },
    error: {
      blank: '比較したい銘柄 or カスタム指数を2つ選んでください。',
      takingLonger: '通常より時間がかかっています。時間を置いて再度アクセスしてください。'
    }
  },
  customIndex: {
    btn: {
      calculating: '計算中...',
      update: 'カスタムインデックスを計算してグラフを更新'
    },
    selectBox: {
      added: '追加',
      deleted: '削除',
    },
    flash: {
      finishCalculation: '計算が完了しました',
      error: '計算中にエラーが発生しました',
      takingLonger: '通常より時間がかかっています。時間を置いて再度アクセスしてください。'
    },
    error: {
      failedCalucualtion: '計算中にエラーが発生しました。contact@gyoseki.comまでご連絡ください。'
    },
    graph: {
      xAxis: '日付',
      yAxis: 'インデックス',
      tooltip: {
        label: '変化率',
      }
    }
  },
  embed: {
    sc: {
      yAxis: {
        label: '株価(円)',
        billion: '(十億円)'
      },
      profitType: {
        op: '営業利益',
        rp: '経常利益',
        ebt: '税前利益'
      }
    }
  },
  financials: {
    thHover: {
      close: 'クリックして四半期を閉じる',
      open: 'クリックして四半期を開く'
    }
  },
  longTermEstimation: {
    btn: {
      save: '保存する',
      saving: '保存中...',
      saved: '保存しました',
    },
    error: {
      failed: '保存に失敗しました'
    },
    validation: {
      blankTerm: '{{dateStr}} の数値を入力してください'
    }
  },
  team: {
    team_members: 'メンバー',
    team_name: 'ユーザー名',
    privilege: '権限',
    gyoseki_id: 'Gyoseki ID',
    status: 'ステータス',
    lock: '操作',
    show_members: 'メンバーを表示',
    showing_members: '表示中',
  }
};
